import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

interface PaymentTypeConfig {
  isAllowed?: boolean;
  isEnable?: boolean;
}

interface PaymentConfig {
  bankPayment?: PaymentTypeConfig | null;
  cardPayment?: PaymentTypeConfig | null;
  cashPayment?: PaymentTypeConfig | null;
  internalPayment?: PaymentTypeConfig | null;
}

export function getOrderPaymentTypeOptions(paymentConfig: PaymentConfig | Nullish) {
  if (!paymentConfig) {
    return [];
  }

  const options = [];

  const isBankPaymentEnabled =
    paymentConfig.bankPayment?.isAllowed || paymentConfig.bankPayment?.isEnable;
  const isCardPaymentEnabled =
    paymentConfig.cardPayment?.isAllowed || paymentConfig.cardPayment?.isEnable;
  const isCashPaymentEnabled =
    paymentConfig.cashPayment?.isAllowed || paymentConfig.cashPayment?.isEnable;
  const isInternalPaymentEnabled =
    paymentConfig.internalPayment?.isAllowed || paymentConfig.internalPayment?.isEnable;

  if (isBankPaymentEnabled) {
    options.push({
      label: i18n.t('entity.invoice.paymentMethod.bankTransfer'),
      value: 'BANK_TRANSFER',
    });
  }

  if (isCardPaymentEnabled) {
    options.push({
      label: i18n.t('entity.invoice.paymentMethod.card'),
      value: 'CARD',
    });
  }

  if (isCashPaymentEnabled) {
    options.push({
      label: i18n.t('entity.invoice.paymentMethod.cash'),
      value: 'CASH',
    });
  }

  if (isInternalPaymentEnabled) {
    options.push({
      label: i18n.t('general.labels.internal'),
      value: 'INTERNAL',
    });
  }

  return options;
}
